'use strict';

/**
 * @author Maxim Seredkin
 * @param {*} $scope
 * @param {*} $rootScope
 * @param {*} $utils
 * @param {*} OperatorService
 * @param {*} SupportStageService
 * @param {*} ProjectService
 */
export default ['$scope', '$rootScope', '$utils', 'OperatorService', 'SupportStageService', 'ProjectService',
                function($scope, $rootScope, $utils, OperatorService, SupportStageService, ProjectService) {
                    $rootScope.title = 'Корзина';

                    $scope.getOperatorDisplayName = OperatorService.getDisplayName;
                    $scope.openControlSidebar = $utils.openControlSidebar;
                    $scope.isBetween = OperatorService.isBetween;
                    $scope.hideFilters = hideFilters;

                    $scope.filter = {};
                    $scope.localFilter = {};

                    $scope.oldFilters = [];
                    $scope.filters = [];

                    $scope.stages = [];

                    init();

                    /**
                     * Инициализация
                     */
                    function init() {
                        $scope.localFilter = ProjectService.getOtherFilters();

                        SupportStageService.api.get({sorts: ['npp:ASC', 'name:ASC']}, (data) => {
                            $scope.stages = [{
                                id: null,
                                name: 'Все',
                            }].concat(data._embedded);

                            if ($scope.localFilter.currentSupportStage) return;

                            let selectedStage = $scope.stages.find((stage) => stage.defaultStage);
                            if (selectedStage) {
                                $scope.localFilter.currentSupportStage = selectedStage.stage;
                                ProjectService.setOtherFilters($scope.localFilter);
                            }
                        });

                        $scope.localFilter.hasExpirationMaintenance = 'ALL';
                        ProjectService.setOtherFilters($scope.localFilter);
                    }

                    /**
                     * Спрятал фильтра
                     */
                    function hideFilters() {
                        if ($scope.filters.length > 0) {
                            $scope.oldFilters = $scope.filters;
                            $scope.filters = [];
                        } else {
                            $scope.isSetFilters = false;
                            $scope.filters = $scope.oldFilters;
                        }
                    }

                    $scope.$watch('filters', function() {
                        $scope.isSetFilters = $scope.filters.length > 0;
                    });

                    $scope.$watch('localFilter', function() {
                        ProjectService.setOtherFilters($scope.localFilter);
                    });
                }];
